<template>
  <div class="container">
    <breadcrumbs></breadcrumbs>
    <title-block
      v-if="selectedFloor"
      :title="selectedFloor.name | titleFilter"
      :callback="GetOrRefreshData"
    ></title-block>

    <b-select v-model="perPage" class="is-size-7 float-right">
      <option value="5">5 per pagina</option>
      <option value="10">10 per pagina</option>
      <option value="15">15 per pagina</option>
      <option value="20">20 per pagina</option>
      <option value="0">alles</option>
    </b-select>

    <b-table
      v-if="selectedFloor"
      :checkable="admin"
      hoverable
      :checked-rows.sync="checkedRows"
      :data="selectedFloor.zones"
      default-sort-direction="asc"
      :paginated="perPage > 0"
      :per-page="perPage"
      @click="row => rowClicked(row)"
    >
      <template>
        <b-table-column cell-class="pointer" field="name" label="Zone" sortable v-slot="props">{{
          props.row.name
        }}</b-table-column>
        <b-table-column cell-class="pointer" field="openingCount" label="# Openingen" sortable numeric v-slot="props">{{
          props.row.openingCount
        }}</b-table-column>
        <b-table-column
          cell-class="pointer"
          field="lastModification"
          label="Laatste modificatie"
          sortable
          numeric
          v-slot="props"
          >{{ new Date(props.row.lastModification).toLocaleDateString('nl-NL') }}</b-table-column
        >
        <b-table-column cell-class="pointer" field="lastModification" label="Status" sortable v-slot="props">
          <span class="tag fixedwidth" :style="statusColor(props.row.lastModification)">{{
            statusText(props.row.lastModification)
          }}</span>
        </b-table-column>
      </template>
      <template slot="bottom-left" v-if="admin">
        <b>Totaal Geselecteerde Rijen</b>
        : {{ checkedRows.length }}
        <!-- <span style="padding-left: 20px">
          <button
            class="button field is-danger"
            @click="
              deleteRows(checkedRows)
              checkedRows = []
            "
            :disabled="!checkedRows.length"
          >
            <b-icon icon="close"></b-icon>
            <span>Delete Selectie</span>
          </button>
        </span> -->
        <span style="padding-left: 20px">
          <button class="button is-primary" @click="isComponentModalActive = true">Voeg Zones Toe</button>
        </span>
      </template>
    </b-table>

    <b-loading
      :is-full-page="true"
      :active="isLoading"
      @close="$store.commit('ISLOADING', false)"
      :can-cancel="true"
    ></b-loading>

    <section>
      <b-modal v-if="selectedFloor" :active.sync="isComponentModalActive" has-modal-card>
        <story-modal
          :buildingId="selectedFloor.buildingId"
          :projectId="project.projectId"
          :story="false"
          @close=";(isComponentModalActive = false), GetOrRefreshData()"
        ></story-modal>
      </b-modal>
    </section>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/General/Breadcrumbs'
import TitleBlock from '@/components/General/TitleBlock'
import { mapGetters } from 'vuex'
import ProjectService from '@/services/projectService'
import rmBtnMixin from '@/mixins/rmBtnMixin.js'
import StoryModal from '@/components/Projects/StoryModal'

export default {
  components: {
    Breadcrumbs,
    TitleBlock,
    StoryModal
  },
  filters: {
    titleFilter: function (value) {
      if (!value.includes('diep') && !value.includes('tory')) {
        return 'Zones ' + 'Verdieping ' + value
      }
      return 'Zones ' + value
    }
  },
  mixins: [rmBtnMixin],

  data() {
    return {
      perPage: 15,
      zonesOverview: [],
      checkedRows: [],
      isComponentModalActive: false,
      admin: false
    }
  },

  computed: {
    ...mapGetters(['project', 'selectedFloor', 'isLoading', 'user', 'adminClaim']),
    floorId() {
      return this.$route.params.floorId
    },
    buildingId() {
      return this.$route.params.buildingId
    },
    projectId() {
      return this.$route.params.projectId
    }
  },

  async mounted() {
    console.log('%cMounted and Loading Data', 'color:yellow;')
    this.checkAdmin()
    if (this.$store.getters.project.projectId != this.projectId) {
      const res = await ProjectService.getProject(this.projectId)
      await this.$store.dispatch('setProject', res.data)
      const index = res.data.buildings.findIndex(o => o.buildingId == this.buildingId)
      const el = res.data.buildings[index]
      const newIndex = el.stories.findIndex(o => o.storyId == this.floorId)
      this.$store.commit('SET_SELECTED_FLOOR', el.stories[newIndex])
      this.GetOrRefreshData()
    }
    const defaultAmountOfRows = 15
    const rows = localStorage.getItem('pagedTableRows')
    this.perPage = rows || defaultAmountOfRows

    if (!this.selectedFloor.zonesDetailsDataFetched) {
      this.GetOrRefreshData()
    }
  },
  beforeDestroy() {
    localStorage.setItem('pagedTableRows', this.perPage)
  },

  methods: {
    async GetOrRefreshData() {
      this.$store.commit('ISLOADING', true)
      let resCount = 0
      this.selectedFloor.zones.forEach(el => {
        ProjectService.getOpeningCountForZone(this.project.projectId, el.zoneId).then(res => {
          el.openingCount = res.data
        })
        ProjectService.getLastModificationForZone(this.project.projectId, el.zoneId)
          .then(res => {
            resCount++
            el.lastModification = res.data
            if (resCount == this.selectedFloor.zones.length) {
              this.$store.commit('ISLOADING', false)
            }
          })
          .catch(err => {
            resCount++
            if (resCount == this.selectedFloor.zones.length) {
              this.$store.commit('ISLOADING', false)
            }
          })
      })
      if (this.selectedFloor.zones.length == 0) {
        this.$store.commit('ISLOADING', false)
      }
      this.selectedFloor.zonesDetailsDataFetched = true
      this.$store.dispatch('updateCrumbs', { name: 'FloorOverview' })
    },
    rowClicked(row) {
      this.$store.commit('SET_SELECTED_ZONE', row)
      this.$router.push('/zoneoverview/' + this.project.projectId + '/' + this.buildingId + '/' + row.zoneId)
    },
    statusColor(data) {
      const d = new Date(data)
      const now = new Date()
      const timeDiff = Math.abs(now.getTime() - d.getTime())
      const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))
      if (diffDays < 100) return 'backgroundColor:#b2f068'
      if (diffDays < 200) return 'backgroundColor:#ffdd75'
      if (diffDays < 365) return 'backgroundColor:#ffba6d'
      return 'backgroundColor:#fe816d'
    },
    statusText(data) {
      const d = new Date(data)
      const now = new Date()
      const timeDiff = Math.abs(now.getTime() - d.getTime())
      const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))
      if (diffDays < 100) return '< 100 dagen'
      if (diffDays < 200) return '< 200 dagen'
      if (diffDays < 365) return '< 1 jaar'
      return '> 1 jaar'
    },
    async deleteRows(rows) {
      let res = ''
      if (rows.length < 1) {
        res = await this.deleteAlert('Zone')
      } else {
        res = await this.deleteAlert('Zones')
      }
      if (res == 'deleted') {
        rows.forEach(async element => {
          await ProjectService.deleteZone(this.project.projectId, element.zoneId)
          this.GetOrRefreshData()
        })
      }
    },
    async checkAdmin() {
      let bool = false
      bool = await this.$store.dispatch('getProjectAdminClaim', this.projectId)
      this.admin = bool
    }
  }
}
</script>

<style lang="scss" scoped>
td {
  cursor: pointer;
}
.fixedwidth {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/Projects/FloorOverview.vue